import moment from 'moment'
import * as React from 'react'
import { connect } from 'react-redux'
import _ from 'underscore'
import { TidewaysContext } from '../../app/context'
import Navigator from '../../app/navigator'
import { ApplicationState } from '../../redux/ApplicationState'
import Chart from '../graph.d3'
import Downstream from '../graph/downstream'

interface OwnProps {
    router: any
    reportMerged?: any
    events: any
    changeActiveSlot: ChangeActiveSlot
}

interface StateProps {
    tidewaysContext: TidewaysContext
    navigator: Navigator
    parameters: { [name: string]: string }
}

type Props = OwnProps & StateProps

type ChangeActiveSlot = (activeSlot: { timeIndex: any; mouse: any }) => void

export class SnapshotComparisonGraph extends React.PureComponent<Props> {
    private chart
    private svg
    private wasChartCreated: boolean = false
    private chartDownstream

    public showTooltip(timestamp, timestampNext, mouse, source) {
        this.props.changeActiveSlot({
            timeIndex: timestamp,
            mouse,
        })

        if (!timestamp) {
            return
        }

        const currentDate = moment(timestamp + 'Z').toDate()
        const nextDate = moment(timestampNext + 'Z').toDate()

        if (source === 'downstream' && this.chart) {
            this.chart.highlight(currentDate, nextDate)
        }

        if (source === 'main' && this.chartDownstream) {
            this.chartDownstream.highlight(currentDate, nextDate)
        }
    }

    public componentDidMount() {
        if (!this.chart) {
            this.chart = new Chart()
        }

        this.checkIfChartCreated()
    }

    public componentDidUpdate(prevProps, prevState) {
        if (!this.chart) {
            this.chart = new Chart()
        }

        this.checkIfChartCreated()
    }

    public componentWillUnmount() {
        this.chart?.destroy()
    }

    public getChartElement = () => {
        return this.svg
    }

    public updateChart = () => {
        if (!this.props.reportMerged) {
            return
        }

        const reportMerged = this.props.reportMerged

        this.chart.update(
            [
                {
                    name: 'requests',
                    data: _.map(reportMerged.requests, (value, key) => {
                        return {
                            axis: 'requests',
                            date: moment(key + 'Z').toDate(),
                            dateUtc: key,
                            value,
                            responseTime: reportMerged.percentileResponseTimes[key] || null,
                            requests: reportMerged.requests[key] || null,
                            errors: reportMerged.errors[key] || null,
                        }
                    }),
                },
                {
                    name: 'response',
                    data: _.map(reportMerged.percentileResponseTimes, (value, key) => {
                        return {
                            axis: 'response',
                            date: moment(key + 'Z').toDate(),
                            dateUtc: key,
                            value,
                        }
                    }),
                },
                {
                    name: 'errors',
                    data: _.map(reportMerged.errors, (value, key) => {
                        return {
                            axis: 'requests',
                            date: moment(key + 'Z').toDate(),
                            dateUtc: key,
                            value,
                        }
                    }),
                },
            ],
            _.map(this.props.events, event => {
                if (!moment.isDate(event.eventDate)) {
                    event.eventDate = moment(event.eventDate + 'Z').toDate()
                }

                return event
            }),
            [],
        )
    }

    public render() {
        return (
            <div>
                <div className="chart">
                    <svg ref={svg => (this.svg = svg)} />
                </div>
                {this.props.reportMerged.hasDownstream ? (
                    <Downstream
                        data={{ report: this.props.reportMerged }}
                        navigator={this.props.navigator}
                        parameters={this.props.parameters}
                        tidewaysContext={this.props.tidewaysContext}
                        onTimestampSelected={(timestamp, timestampNext, mouse) =>
                            this.showTooltip(timestamp, timestampNext, mouse, 'downstream')
                        }
                        onChartCreated={chart => {
                            this.chartDownstream = chart
                        }}
                        idSuffix="__snapshotComparison"
                    />
                ) : null}
            </div>
        )
    }

    private checkIfChartCreated() {
        if (!this.wasChartCreated) {
            const chartElement = this.getChartElement()
            const parentNode = jQuery(chartElement).parent()
            this.chart.create(chartElement, parentNode.width(), Math.max(parentNode.height(), 180), (timeIndex, timeIndexNext, mouse) =>
                this.showTooltip(timeIndex, timeIndexNext, mouse, 'main'),
            )

            jQuery(chartElement).on('eventClicked', (event, group) => {
                if (!group || !group.length || !group[0] || !group[0].id) {
                    return
                }

                this.props.router.goTo('XhprofProfilerBundle.Event.show', { event: group[0].id })
            })

            jQuery(chartElement).on('rangeSelected', (event, dataSet, nextDataSet) => {
                this.props.router.goTo('XhprofProfilerBundle.Snapshot.show', {
                    date: moment(dataSet.date)
                        .utc()
                        .format('YYYY-MM-DD HH:mm'),
                    end: moment(nextDataSet.date)
                        .utc()
                        .format('YYYY-MM-DD HH:mm'),
                })
            })

            jQuery(chartElement).on('rangeDelesect', event => {
                this.props.router.goTo('XhprofOrganizationBundle.Application.show')
            })

            this.wasChartCreated = true
        }

        if (this.props.reportMerged) {
            this.updateChart()
        }
    }
}

export default connect<StateProps, {}>((globalState: ApplicationState, props) => {
    return {
        tidewaysContext: globalState.tidewaysContext,
        navigator: new Navigator(globalState.tidewaysContext.route),
        parameters: globalState.tidewaysContext.route.parameters,
    }
})(SnapshotComparisonGraph)
